import { configurationGroupTimes } from './configurationGroupTimes';

export const inclusionsWithoutTimes = [
  {
    id: 80,
    name: null,
    minimumSelections: null,
    maximumSelections: null,
    optionsPerGuest: true,
    isExtras: false,
    supportsSelections: false,
    isRequired: false,
    isBookable: true,
    supportsTimeslots: false,
    options: [
      {
        id: 351,
        name: 'Bath Robe',
        description: null,
        image: null,
        price: null,
        extra: {
          id: 32,
        },
      },
      {
        id: 352,
        name: 'Slippers',
        description: null,
        image: null,
        price: null,
        extra: {
          id: 32,
        },
      },
    ],
  },
];

export const inclusionsWithTimes = [
  {
    id: 16,
    name: null,
    minimumSelections: null,
    maximumSelections: null,
    optionsPerGuest: true,
    isExtras: false,
    supportsSelections: false,
    isRequired: true,
    isBookable: true,
    supportsTimeslots: true,
    options: [
      {
        id: 401,
        name: 'Aromatherapy',
        description: null,
        image: null,
        price: null,
        extra: null,
        ...configurationGroupTimes,
      },
      {
        id: 367,
        name: 'Spa Lunch',
        description: null,
        image: null,
        price: null,
        extra: null,
        ...configurationGroupTimes,
      },
    ],
  },
];
